import type { cast as castNs } from 'chromecast-caf-receiver';
import type { MediaInformation } from 'chromecast-caf-receiver/cast.framework.messages';

declare const cast: typeof castNs;

export const getExpectedTrackIdsInMediaStatus = (
    media: MediaInformation,
    activeTrackIds: number[],
    audioTracksWithForcedTextTracks: number[]
): number[] => {
    let tracks = media.tracks;
    if (!tracks) {
        return [];
    }
    if (activeTrackIds?.some((trackId) => audioTracksWithForcedTextTracks.includes(trackId))) {
        tracks = tracks.filter((track) => track.type !== cast.framework.messages.TrackType.TEXT);
    }
    return tracks.map(({ trackId }) => trackId);
};
